import React, { useState } from 'react'
import styles from './SettingIndicator.module.scss'
import { Props } from './types'
import { IconButton } from 'components'
import { icons } from 'assets'
import { capitalize } from 'utilities'

const SettingIndicator = (props: Props) => {
  const { label, generalUse, removeCropping } = props

  const [hover, setHover] = useState(false)

  let timeout = null

  const handleMouseEnter = () => {
    if (!removeCropping) return
    timeout = setTimeout(() => setHover(true), 150)
  }

  const handleMouseLeave = () => {
    if (timeout) {
      clearTimeout(timeout)
    }
    hover && setHover(false)
  }
  const text = generalUse ? `${label} *` : label
  let title = `Has ${capitalize(label)} cropping.`
  generalUse && (title = title.replace('.', ' for General use.'))

  return (
    <div
      className={styles[label]}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      title={title}
    >
      {text}

      {hover && (
        <IconButton
          icon={icons.closeX}
          className={styles.xBttn}
          title={`Remove ${label} cropping`}
          onClick={() => removeCropping(label)}
        />
      )}
    </div>
  )
}

export default SettingIndicator
